import script from "./UDecimalInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDecimalInput.vue?vue&type=script&setup=true&lang=ts"

import "./UDecimalInput.vue?vue&type=style&index=0&id=52fa1ebb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52fa1ebb"]])

export default __exports__